export class GoogleTranslateHelper {
    static isGoogleTranslateDomain(domain) {
        return domain.endsWith('.translate.goog');
    }
    static getDomainFromTranslateDomain(domain) {
        if (this.isGoogleTranslateDomain(domain)) {
            // Strip it out
            let cleaned = domain.substr(0, domain.length - ('.translate.goog').length);
            // Replace dashes with points
            cleaned = cleaned.replace(/-/g, '.');
            // Replace double points with dashes
            cleaned = cleaned.replace(/\.\./g, '-');
            return cleaned;
        }
        return domain;
    }
}
//# sourceMappingURL=GoogleTranslateHelper.js.map